// Searchanise shows a video's poster image (Shopify "/files/preview_images/" path) when a video is a
// product's first media, instead of a real photo. This swaps it for the product's featured image.
// The thumbnail is hidden by CSS (searchanise.css) until data-video-poster-fixed is set below.

(function () {
  const THUMBNAIL_SELECTOR = '.snize-item-image[src*="/files/preview_images/"]:not([data-video-poster-fixed])';

  function fixVideoPosterThumbnails() {
    document.querySelectorAll(THUMBNAIL_SELECTOR).forEach((img) => {
      const handle = (img.closest('a[href*="/products/"]')?.getAttribute('href') || '').match(/\/products\/([^/?#]+)/)?.[1];
      if (!handle) {
        img.dataset.videoPosterFixed = 'true';
        return;
      }

      fetch(`/products/${handle}.js`)
        .then((response) => (response.ok ? response.json() : null))
        .catch(() => null)
        .then((product) => {
          if (product?.featured_image) img.src = product.featured_image;
          img.dataset.videoPosterFixed = 'true';
        });
    });
  }

  let timer;
  function scheduleFix() {
    clearTimeout(timer);
    timer = setTimeout(fixVideoPosterThumbnails, 50);
  }

  // Runs now and on every re-render; the async script may miss Searchanise.Loaded.
  function start() {
    scheduleFix();
    new MutationObserver(scheduleFix).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('Searchanise.DataRequestEnd', scheduleFix);
  }

  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  }
})();
